import axios from 'axios';
import authApi from '../api/auth';
import customLocalStorage from './localStorageWithExpire';

export const axiosApiInstance = axios.create();


// Adds access token to request if available. Resolves with response if not available
axiosApiInstance.interceptors.request.use(
    config => {
        // const accessToken = customLocalStorage.getWithExpire("ACCESS_TOKEN");
        const accessToken = customLocalStorage.getToken("ACCESS_TOKEN")
        if (accessToken) {
            config.headers = Object.assign({
                'Authorization': accessToken.value,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }, config.headers)
        }
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

// Intercept responses and retry if necessary. This is called in response. use so we don't have to worry about re - issuing requests
axiosApiInstance.interceptors.response.use(response => {
    return response
}, async error => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
        console.log("DEBUG: 2");
        originalRequest._retry = true;
        await authApi.refreshToken();
        const token = customLocalStorage.getToken("ACCESS_TOKEN");

        if (!token) return Promise.reject(error);

        originalRequest.headers['Authorization'] = token.value;
        originalRequest.baseURL = undefined;
        return axiosApiInstance.request(originalRequest);

    }
    return Promise.reject(error);
});